import React, { Component } from 'react'
import './index.css'
import Alert from '../Alert';
import { connect } from 'react-redux';
import { resetToastNotification, showToastNotification } from '../../actions/toastNotification';

class Toast extends Component {
  constructor(props) {
    super(props);

    this.hideElement = this.hideElement.bind(this);
  }

  hideElement() {
    this.props.resetToastNotification();
  }

  componentDidUpdate(prevProps) {
    if (this.props.toastNotification.text != prevProps.toastNotification.text) {
      setTimeout(() => this.hideElement(), 5000);
    }
  }

  render() {

    if (!this.props.toastNotification.text) {
      return <></>;
    }

    return (
      <div class="toast-component">
        <Alert title={this.props.toastNotification?.title} variant={this.props.toastNotification?.variant} onDismiss={this.hideElement}>
          {this.props.toastNotification?.text}
        </Alert>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  toastNotification: state.toastNotification,
})

const mapDispatchToProps = dispatch => ({
  showToastNotification: data => dispatch(showToastNotification(data)),
  resetToastNotification: () => dispatch(resetToastNotification()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Toast)

